<template>
  <div class="terms-outline">
    <p class="title">{{ content.header[0].content }}</p>
    <Depth2Content :content="content" />
  </div>
</template>
<script>
import Depth2Content from './Depth2Content.vue'

export default {
  props: {
    content: Object,
    parentIndexes: Array,
  },
  components: {
    Depth2Content,
  },
}
</script>
<style lang="scss" scoped>
@import '../TermsOfUse.scss';
</style>
